module.exports = __webpack_public_path__ + "img/瑞兹.e6290f17.png";